import React, { Component } from 'react';

export default function SiteFooter(props) {
	return <div className="footer">
		<div className="footer-content lang-is">Stofnun Árna Magnússonar í íslenskum fræðum, Árnagarði við Suðurgötu, 102 Reykjavík.<br/>Gefið út með <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank">CC-BY leyfi</a>.</div>
		<div className="logos">
			<a target="_blank" href="https://arnastofnun.is"><img src="/img/logo-sam.png" alt="Stofnun Árna Magnússonar í íslenskum fræðum" title="Stofnun Árna Magnússonar í íslenskum fræðum" /></a>
			<a target="_blank" href="https://lmi.is"><img src="/img/logo-lmi.png" alt="Landmælingar íslands" title="Landmælingar íslands" /></a>
			<a target="_blank" href="https://rannis.is"><img src="/img/logo-rannis.png" alt="Rannís" title="Rannís" /></a>
			<a target="_blank" href="https://hi.is"><img src="/img/logo-hi-2.png" alt="Styrktarsjóður Áslaugar Hafliðadóttur" title="Styrktarsjóður Áslaugar Hafliðadóttur" /></a>
		</div>
	</div>;
}



// WEBPACK FOOTER //
// ./src/components/SiteFooter.js